import styled from 'styled-components';

import { IOptionLabel } from './OptionLabel';

export const Wrapper = styled.button<IOptionLabel.IProps>`
  display: flex;
  align-items: center;
  min-width: 539px;
  height: 56px;
  padding: 0 24px;
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.primaryGreen50 : theme.colors.gray0};
  border: 1px solid
    ${({ theme, isSelected }) => (isSelected ? theme.colors.primaryGreen500 : theme.colors.gray50)};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin: ${({ marginWrapper }) => marginWrapper && marginWrapper};
  gap: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray700};
  font-size: ${({ theme }) => theme.typeSize.sm};
  line-height: ${({ theme }) => theme.typeSize.md};
  user-select: none;
  z-index: 2;

  @media only screen and ${({ theme }) => theme.breakpoints.tablet} {
    min-width: auto;
    text-align: start;
    padding: 0 22px;
  }
`;

export const CheckIcon = styled.span`
  font-size: 16px;
`;
